var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpinChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.002,
    height: 18,
    viewBox: "0 0 16.002 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xDAnpin",
    transform: "translate(-766.027 -489.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M19.275,13.016",
    transform: "translate(761.113 487.276)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291",
    transform: "translate(766.027 489.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M6.372,11.847c1.294-.306,1.556-2.02,1.556-4.488v-4.1",
    transform: "translate(-2.865 -2.477)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M7.928,11.973c-1.294-.311-1.556-2.05-1.556-4.554V3.255",
    transform: "translate(4.346 -2.604)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    transform: "translate(0 8.592)",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.002,
    height: 1.5,
    rx: 0.75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    transform: "translate(7.223 8.592)",
    fill: "#fff",
    stroke: "#0d0d0d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.556,
    height: 7.852,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.556,
    height: 6.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    transform: "translate(8.779 18) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.778,0l.778,1.556H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.7778966426849365 -3.457069396972656e-06 L 1.55579662322998 1.55579662322998 L -3.337860107421875e-06 1.55579662322998 L 0.7778966426849365 -3.457069396972656e-06 Z",
    stroke: "none",
    fill: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    transform: "translate(2.815)",
    stroke: "#0d0d0d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.372,
    height: 1.556,
    rx: 0.778,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9.372,
    height: 0.556,
    rx: 0.278,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x2: 13,
    y2: 12,
    transform: "translate(767.529 492.363)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinChatIcon);
export default __webpack_public_path__ + "static/media/unpin-chat-icon.9e26c0689d672a024ad5ecfdbef27416.svg";
export { ForwardRef as ReactComponent };